import React from 'react';
import { motion } from 'framer-motion';
import { SectionTag } from './SectionTag';
import { PAIN_SITUATIONS } from './salesData';

/**
 * Identificación del dolor: situaciones que cualquiera que venda por WhatsApp
 * reconoce al instante. Se muestran como burbujas de chat entrantes.
 */
export function PainSection() {
  return <section className="w-full bg-white py-16 sm:py-20" data-id="element-145" data-mp="2yyfvmlg3o4hm">
      <div className="mx-auto w-full max-w-5xl px-5 sm:px-6" data-id="element-146" data-mp="2l8m2vs1h502m">
        <div className="max-w-2xl" data-id="element-147" data-mp="2l69cqrlkbjeh">
          <SectionTag data-id="element-148" data-mp="2pyst1wbmwsmz">El problema real</SectionTag>
          <h2 className="mt-4 font-display text-[1.85rem] font-extrabold leading-tight text-ink sm:text-[2.4rem]" data-id="element-149" data-mp="2q0dkve6kdxh5">
            Sabés perfectamente de qué estamos hablando…
          </h2>
          <p className="mt-3 font-sans text-[1.02rem] leading-relaxed text-slate" data-id="element-150" data-mp="2ga0zxkuu82ah">
            La consulta llega. La conversación arranca. Y después se apaga sola.
          </p>
        </div>

        <ul className="mt-9 grid gap-3 sm:grid-cols-2" data-id="element-151" data-mp="2779ohl1yp6iu">
          {PAIN_SITUATIONS.map((situation, index) => <motion.li key={situation} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.28,
          delay: Math.min(index * 0.04, 0.2),
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-3 rounded-2xl rounded-tl-md border border-fog bg-mist px-4 py-3.5" data-id="element-152" data-mp="3rlfz3u5tt98s" data-mpi={index}>
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-slate-soft" aria-hidden data-id="element-153" data-mp="33z11cff6ktpy" />
              <p className="font-sans text-[0.95rem] leading-snug text-ink" data-id="element-154" data-mp="3inx90bdbs4q1">{situation}</p>
            </motion.li>)}
        </ul>

        <p className="mt-8 max-w-2xl font-display text-[1.05rem] font-bold leading-snug text-ink sm:text-[1.2rem]" data-id="element-155" data-mp="2q61pcnelxhn5">
          No perdiste la venta por el precio. La perdiste por el mensaje que mandaste
          después.
        </p>
      </div>
    </section>;
}